import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ConsultCtaBand from "../components/ConsultCtaBand";
import { Check, AlertOctagon } from "lucide-react";

import useDocumentTitle from "../hooks/useDocumentTitle";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  useDocumentTitle('Unsubscribe — QorTrace');
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, msg: "Missing unsubscribe token." }); return; }
    axios.get(`${API}/unsubscribe`, { params: { token } })
      .then(({ data }) => setState({ loading: false, ok: true, msg: data.message }))
      .catch((err) => setState({ loading: false, ok: false, msg: err?.response?.data?.detail || "Could not process unsubscribe link." }));
  }, [token]);

  return (
    <div className="min-h-screen qt-radial-bg" data-testid="unsubscribe-page">
      <Header />
      <section className="max-w-[720px] mx-auto px-6 py-20">
        <div className="qt-card">
          <div className="qt-label">EMAIL PREFERENCES</div>
          <h1 className="qt-h2 text-3xl mt-2">Unsubscribe</h1>
          {state.loading ? (
            <p className="text-sm mt-4" style={{ color: "var(--qt-text-2)" }}>Processing…</p>
          ) : state.ok ? (
            <div className="mt-4">
              <div className="flex items-center gap-2"><Check size={16} style={{ color: "#1FDD83" }} />
                <span className="qt-label" style={{ color: "#1FDD83" }}>UNSUBSCRIBED</span></div>
              <p className="text-sm mt-3" style={{ color: "var(--qt-text-2)" }}>{state.msg}</p>
              <p className="text-sm mt-2" style={{ color: "var(--qt-text-3)" }}>
                You'll no longer receive marketing emails or free preview reports. Sign in to your account
                anytime to re-enable.
              </p>
              <Link to="/" className="qt-btn qt-btn-secondary mt-4">Back to QorTrace</Link>
            </div>
          ) : (
            <div className="mt-4">
              <div className="flex items-center gap-2"><AlertOctagon size={16} style={{ color: "#FF6E6E" }} />
                <span className="qt-label" style={{ color: "#FF6E6E" }}>FAILED</span></div>
              <p className="text-sm mt-3" style={{ color: "var(--qt-text-2)" }}>{state.msg}</p>
            </div>
          )}
        </div>
      </section>
      <ConsultCtaBand source="unsubscribe-bottom-cta" variant="card" />
      <Footer />
    </div>
  );
}
